import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import { useLanguage } from '../../context/LanguageContext';

const API = '/api/v1/fsm';

const PriceBooks = () => {
  const { lang, t } = useLanguage();
  const f = t('fsm');
  const isRTL = lang === 'ar';

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [saving, setSaving] = useState(false);

  const [formData, setFormData] = useState({
    name: '', name_ar: '', description: '', currency: 'EGP',
    labor_rate_per_hour: '', overtime_multiplier: '1.5',
    emergency_multiplier: '2.0', parts_markup_percent: '0', is_default: 0
  });

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const inputSt = {
    width: '100%', padding: '12px', border: '2px solid rgba(255,255,255,0.2)',
    borderRadius: '8px', backgroundColor: '#1a2038', color: '#f9fafb', fontSize: '14px',
    outline: 'none', boxSizing: 'border-box'
  };

  const labelSt = { display: 'block', marginBottom: '8px', color: '#d1d5db', fontSize: '13px', fontWeight: '500' };

  const sectionSt = {
    backgroundColor: 'rgba(26, 32, 56, 0.8)', padding: '25px', borderRadius: '12px',
    marginBottom: '20px', border: '1px solid rgba(255, 255, 255, 0.1)'
  };

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API}/price-books`, { headers: { 'Authorization': `Bearer ${token}` } });
      if (res.ok) { const d = await res.json(); if (d.success) setItems(d.data || []); }
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchData(); }, []);

  const openNew = () => {
    setEditItem(null);
    setFormData({ name: '', name_ar: '', description: '', currency: 'EGP',
      labor_rate_per_hour: '', overtime_multiplier: '1.5',
      emergency_multiplier: '2.0', parts_markup_percent: '0', is_default: 0 });
    setShowModal(true);
  };

  const openEdit = (item) => {
    setEditItem(item);
    setFormData({
      name: item.name || '', name_ar: item.name_ar || '', description: item.description || '',
      currency: item.currency || 'EGP',
      labor_rate_per_hour: item.labor_rate_per_hour || '',
      overtime_multiplier: item.overtime_multiplier || '1.5',
      emergency_multiplier: item.emergency_multiplier || '2.0',
      parts_markup_percent: item.parts_markup_percent || '0',
      is_default: item.is_default || 0
    });
    setShowModal(true);
  };

  const handleSave = async () => {
    if (!formData.name) return;
    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      const url = editItem ? `${API}/price-books/${editItem.id}` : `${API}/price-books`;
      const method = editItem ? 'PUT' : 'POST';
      const res = await fetch(url, {
        method,
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const data = await res.json();
      if (data.success) { setShowModal(false); fetchData(); }
    } catch (err) { console.error(err); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm(lang === 'ar' ? 'هل تريد الحذف؟' : 'Delete this price book?')) return;
    try {
      const token = localStorage.getItem('token');
      await fetch(`${API}/price-books/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      fetchData();
    } catch (err) { console.error(err); }
  };

  return (
    <Layout>
    <div style={{ direction: isRTL ? 'rtl' : 'ltr', padding: '30px', maxWidth: '900px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px' }}>
        <div>
          <h1 style={{ margin: 0, fontSize: '24px', fontWeight: '700', color: '#f9fafb' }}>{f.price_books_title || 'Price Books'}</h1>
          <p style={{ margin: '4px 0 0', color: '#9ca3af', fontSize: '14px' }}>{f.price_books_subtitle || 'Manage labor rates, multipliers, and parts markup'}</p>
        </div>
        <button onClick={openNew} style={{
          padding: '10px 20px', borderRadius: '8px', border: 'none',
          backgroundColor: '#007bff', color: '#fff', fontWeight: '600', cursor: 'pointer', fontSize: '14px'
        }}>+ {f.new_price_book || 'New Price Book'}</button>
      </div>

      {loading ? (
        <div style={{ padding: '60px', textAlign: 'center', color: '#9ca3af' }}>{f.loading || 'Loading...'}</div>
      ) : items.length === 0 ? (
        <div style={{ padding: '60px', textAlign: 'center', color: '#9ca3af' }}>
          <div style={{ fontSize: '40px', marginBottom: '12px' }}>💰</div>
          <p>{f.no_price_books || 'No price books yet'}</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '16px' }}>
          {items.map(item => (
            <div key={item.id} style={{ ...sectionSt, position: 'relative', marginBottom: 0 }}>
              {item.is_default ? (
                <span style={{ position: 'absolute', top: 12, left: isRTL ? 'auto' : 12, right: isRTL ? 12 : 'auto',
                  backgroundColor: 'rgba(66,133,244,0.2)', color: '#4285F4', padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600'
                }}>{f.default_label || 'Default'}</span>
              ) : null}
              <h3 style={{ margin: '0 0 4px', fontSize: '16px', fontWeight: '600', color: '#f9fafb' }}>
                {lang === 'ar' ? (item.name_ar || item.name) : item.name}
              </h3>
              {item.description && <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#9ca3af' }}>{item.description}</p>}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '13px' }}>
                <div><span style={{ color: '#9ca3af' }}>{f.pb_labor || 'Labor/hr'}:</span> <strong style={{ color: '#f9fafb' }}>{item.labor_rate_per_hour || '—'} {item.currency}</strong></div>
                <div><span style={{ color: '#9ca3af' }}>{f.pb_overtime || 'Overtime'}:</span> <strong style={{ color: '#f9fafb' }}>{item.overtime_multiplier}x</strong></div>
                <div><span style={{ color: '#9ca3af' }}>{f.pb_emergency || 'Emergency'}:</span> <strong style={{ color: '#f9fafb' }}>{item.emergency_multiplier}x</strong></div>
                <div><span style={{ color: '#9ca3af' }}>{f.pb_markup || 'Parts Markup'}:</span> <strong style={{ color: '#f9fafb' }}>{item.parts_markup_percent}%</strong></div>
              </div>
              <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
                <button onClick={() => openEdit(item)} style={{
                  flex: 1, padding: '8px 12px', borderRadius: '8px', border: '2px solid rgba(255,255,255,0.15)',
                  backgroundColor: 'transparent', color: '#d1d5db', cursor: 'pointer', fontSize: '13px'
                }}>✏️ {f.edit || 'Edit'}</button>
                {!item.is_default && (
                  <button onClick={() => handleDelete(item.id)} style={{
                    padding: '8px 12px', borderRadius: '8px', border: '2px solid rgba(255,255,255,0.15)',
                    backgroundColor: 'transparent', color: '#ff6b6b', cursor: 'pointer', fontSize: '13px'
                  }}>🗑️</button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }} onClick={() => setShowModal(false)}>
          <div onClick={e => e.stopPropagation()} style={{
            backgroundColor: '#151b30', borderRadius: '16px', padding: '25px', width: '90%', maxWidth: '500px',
            maxHeight: '80vh', overflow: 'auto', direction: isRTL ? 'rtl' : 'ltr',
            border: '1px solid rgba(255,255,255,0.1)'
          }}>
            <h3 style={{ margin: '0 0 20px', fontSize: '18px', fontWeight: '600', color: '#f9fafb' }}>
              {editItem ? (f.edit_price_book || 'Edit Price Book') : (f.new_price_book || 'New Price Book')}
            </h3>
            <div style={{ display: 'grid', gap: '12px' }}>
              <div>
                <label style={labelSt}>{f.name_en || 'Name (EN)'} *</label>
                <input type="text" value={formData.name} onChange={(e) => handleChange('name', e.target.value)} style={inputSt} />
              </div>
              <div>
                <label style={labelSt}>{f.name_ar_label || 'Name (AR)'}</label>
                <input type="text" value={formData.name_ar} onChange={(e) => handleChange('name_ar', e.target.value)} style={{ ...inputSt, direction: 'rtl' }} />
              </div>
              <div>
                <label style={labelSt}>{f.description || 'Description'}</label>
                <input type="text" value={formData.description} onChange={(e) => handleChange('description', e.target.value)} style={inputSt} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={labelSt}>{f.pb_labor || 'Labor Rate/hr'}</label>
                  <input type="text" value={formData.labor_rate_per_hour} onChange={(e) => handleChange('labor_rate_per_hour', e.target.value)} style={inputSt} />
                </div>
                <div>
                  <label style={labelSt}>{f.currency || 'Currency'}</label>
                  <input type="text" value={formData.currency} onChange={(e) => handleChange('currency', e.target.value)} style={inputSt} />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={labelSt}>{f.pb_overtime || 'Overtime'} (x)</label>
                  <input type="text" value={formData.overtime_multiplier} onChange={(e) => handleChange('overtime_multiplier', e.target.value)} style={inputSt} />
                </div>
                <div>
                  <label style={labelSt}>{f.pb_emergency || 'Emergency'} (x)</label>
                  <input type="text" value={formData.emergency_multiplier} onChange={(e) => handleChange('emergency_multiplier', e.target.value)} style={inputSt} />
                </div>
                <div>
                  <label style={labelSt}>{f.pb_markup || 'Parts Markup'} (%)</label>
                  <input type="text" value={formData.parts_markup_percent} onChange={(e) => handleChange('parts_markup_percent', e.target.value)} style={inputSt} />
                </div>
              </div>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', color: '#d1d5db', fontSize: '14px' }}>
                <input type="checkbox" checked={!!formData.is_default}
                  onChange={(e) => handleChange('is_default', e.target.checked ? 1 : 0)}
                  style={{ width: 18, height: 18 }} />
                {f.set_as_default || 'Set as default'}
              </label>
            </div>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button onClick={() => setShowModal(false)} style={{
                padding: '10px 20px', borderRadius: '8px', border: '2px solid rgba(255,255,255,0.2)',
                backgroundColor: 'transparent', cursor: 'pointer', color: '#d1d5db', fontSize: '14px'
              }}>{f.cancel || 'Cancel'}</button>
              <button onClick={handleSave} disabled={saving} style={{
                padding: '10px 20px', borderRadius: '8px', border: 'none',
                backgroundColor: saving ? '#6c757d' : '#007bff', color: '#fff',
                fontWeight: '600', cursor: saving ? 'not-allowed' : 'pointer', fontSize: '14px'
              }}>{saving ? (f.saving || 'Saving...') : (f.save || 'Save')}</button>
            </div>
          </div>
        </div>
      )}
    </div>
    </Layout>
  );
};

export default PriceBooks;